import React from 'react';
import EDBarChart from '../../../../../BaseComponents/Charts/BarChart/EDBarChart';
import {
  FormatterCallbackFunction,
  AxisLabelsFormatterContextObject,
  DrilldownEventObject,
  SeriesOptionsType,
} from 'highcharts';
import GraphPanel from '../GraphPanel/GraphPanel';

interface IProps {
  title?: string;
  link?: string;
  yAxisLabel: string;
  formater?: FormatterCallbackFunction<AxisLabelsFormatterContextObject>;
  categories: string[];
  series: SeriesOptionsType[];
  drilldownEvent?: (event: DrilldownEventObject) => void;
}

class BarChartPanel extends React.PureComponent<IProps> {
  render() {
    return (
      <GraphPanel type="column" title={this.props.title} link={this.props.link}>
        <EDBarChart
          yAxisLabel="Värde - kr"
          categories={this.props.categories}
          series={this.props.series}
          drilldownEvent={this.props.drilldownEvent}
          formater={this.props.formater}
        />
      </GraphPanel>
    );
  }
}

export default BarChartPanel;
